import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { Shield } from '@mui/icons-material';

/**
 * Explicación permanente de la regla de privacidad del panel. Va a la vista, no a un tooltip:
 * en una empresa pequeña casi todo aparece protegido y sin este texto la pantalla se lee como
 * una app rota en vez de como la garantía que es.
 */
function PrivacyNote({ variant = 'default' }) {
  const { t } = useTranslation(['orgClient']);

  const body =
    variant === 'empty'
      ? t('privacy.emptyBody', {
          defaultValue:
            'Todavía no hay suficientes respuestas para mostrar un resultado. El bienestar se publica solo cuando responden 5 personas o más dentro del mismo grupo, así nadie queda expuesto. A medida que tu equipo responda el check-in semanal, los datos van apareciendo.'
        })
      : t('privacy.body', {
          defaultValue:
            'Ves promedios anónimos de tu equipo y el uso de la app, nunca el bienestar de una persona concreta. Los grupos de menos de 5 respuestas quedan protegidos.'
        });

  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{
        p: 2,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'hairline.main',
        backgroundColor: 'surface.overlay'
      }}>
      <Box sx={{ display: 'flex', color: 'gold.main', pt: 0.25 }}>
        <Shield sx={{ fontSize: 20 }} />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
          {t('privacy.title', { defaultValue: 'Privacidad primero' })}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>
          {body}
        </Typography>
      </Box>
    </Stack>
  );
}

PrivacyNote.propTypes = {
  /** 'empty' explica por qué no hay datos todavía; 'default' es la nota de contexto. */
  variant: PropTypes.oneOf(['default', 'empty'])
};

export default PrivacyNote;
